'use client';

import cx from 'classnames';
import { useTranslations } from 'next-intl';
import { CatButton } from '@blocks-react/components/Button';
import { CatPopover } from '@blocks-react/components/Popover';
import ContactDealerPopoverContent from '../contact-dealer-popover-content/contact-dealer-popover-content';
import { LocationAddress } from 'services/location/types';
import { Position, Variant, Size } from '../types';
import styles from './contact-your-dealer-popover.module.scss';
import { useEsiteCtx } from 'services/esite/context';

type contactDealerCTAProps = {
  gaprimaryCTA: string;
  gaBtnEventName: string;
  gaEventContext: string;
};
interface ContactYourDealerPopoverProps {
  dealerAddress: LocationAddress;
  position?: Position;
  isCustomerSupportEnabled?: boolean;
  variant?: Variant;
  className?: string;
  size?: Size;
  responsiveBehavior?: boolean;
  msg?: string;
  shouldFitContent?: boolean;
  shouldMaxContent?: boolean;
  gaEventDetails?: contactDealerCTAProps;
  fullWidth?: boolean;
  kitDrawer?: boolean;
  classname?: string;
}
export default function ContactYourDealerPopover({
  dealerAddress,
  position = 'bottom',
  isCustomerSupportEnabled = false,
  variant,
  className = 'w-100 d-grid',
  size = 'sm',
  responsiveBehavior = true,
  msg,
  shouldFitContent,
  shouldMaxContent,
  gaEventDetails,
  fullWidth = true,
  kitDrawer = false,
  classname
}: Readonly<ContactYourDealerPopoverProps>) {
  const t = useTranslations();
  const { locale } = useEsiteCtx();
  const popoverTitle = msg || t('CONTACT_YOUR_DEALER');
  return (
    <CatPopover
      {...(responsiveBehavior && { behavior: 'responsive' })}
      headingVariant="title-sm"
      heading={t('FOOTER_CONTACT_US')}
      className={cx(kitDrawer ? '' : className, {
        [styles['contact-dealer-popover--fit-content']]: shouldFitContent,
        [styles['contact-dealer-popover--max-content']]: shouldMaxContent
      })}
      position={position}
    >
      {kitDrawer ? (
        <CatButton
          variant={variant}
          slot="trigger"
          className={styles['dealer-button-table']}
          data-track-event={gaEventDetails?.gaprimaryCTA}
          data-track-attr-nltext={gaEventDetails?.gaBtnEventName}
          data-track-attr-context={gaEventDetails?.gaEventContext}
        >
          <span className={classname}>{popoverTitle}</span>
        </CatButton>
      ) : (
        <CatButton
          {...(variant && { variant })}
          size={size}
          fullWidth={fullWidth}
          slot="trigger"
          className={cx(
            {
              [styles['contact-dealer-popover__button--max-content']]:
                shouldMaxContent,
              [styles['contact-dealer-popover__button--text-start']]:
                variant === 'inline'
            },
            'h-100'
          )}
          data-track-event={gaEventDetails?.gaprimaryCTA}
          data-track-attr-nltext={gaEventDetails?.gaBtnEventName}
          data-track-attr-context={gaEventDetails?.gaEventContext}
        >
          <span className={classname}> {popoverTitle}</span>
        </CatButton>
      )}
      <ContactDealerPopoverContent
        dealerAddress={dealerAddress}
        locale={locale}
        isCustomerSupportEnabled={isCustomerSupportEnabled}
      />
    </CatPopover>
  );
}
